import * as React from "react";
import { useContext, useMemo } from "react";
import { Colors } from "@skbkontur/extern-colors";
import { ThemeContext } from "@emotion/react";
import { Theme, DEFAULT_THEME } from "react-ui";

import { Button } from "../../../Action/Button/Button";

export const DeleteBlockButton = (props: { onClick: () => void }) => {
    const defaultTheme = useContext(ThemeContext);

    const theme: Theme = useMemo(
        () => ({
            ...DEFAULT_THEME,
            linkColor: Colors.textRed,
            linkHoverColor: Colors.red100,
            linkActiveColor: Colors.red110,
        }),
        [defaultTheme]
    );

    return <Button use={"link"} icon={"XIcon"} value="Удалить" theme={theme} onClick={props.onClick} />;
};
